import { render, staticRenderFns } from "./complaint-proposal.vue?vue&type=template&id=e359dba8&scoped=true"
import script from "./complaint-proposal.vue?vue&type=script&lang=js"
export * from "./complaint-proposal.vue?vue&type=script&lang=js"
import style0 from "./complaint-proposal.vue?vue&type=style&index=0&id=e359dba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e359dba8",
  null
  
)

export default component.exports